/*
 * Copyright (C) 2024 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and
 * should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly
 * prohibited.
 */

import { Box } from '@mui/material';
import { useEffect } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import {
  selectIsRequestingServiceTierRequests,
  selectIsUpdatingServiceTierRequest,
  selectPendingServiceRequestsAsArray,
  selectRequestingServiceTierRequestsError,
  selectUpdatingServiceTierRequestError,
} from '../../../store';
import {
  cancelServiceTierRequestsPoll,
  clearReceivedServiceTierRequestsError,
  getServiceTierRequests,
} from '../../../store/serviceTierRequests/actions';
import ErrorMessage from '../../common/layout/ErrorMessage';
import ModalLoadingSpinner from '../../common/layout/ModalLoadingSpinner';
import appTheme from '../../common/theme/appTheme.json';
import ServiceTierRequestsTable from './ServiceTierRequestsTable';
import { StyledProvisioningPageHeading } from '../StyledProvisioningPageHeading';

const ServiceTierChangeRequests = () => {
  const dispatch = useDispatch();

  //selectors
  const pendingServiceChangeRequests = useSelector(selectPendingServiceRequestsAsArray, shallowEqual);
  const loadingServiceChangeRequests = useSelector(selectIsRequestingServiceTierRequests, shallowEqual);
  const serviceChangeRequestsError = useSelector(selectRequestingServiceTierRequestsError, shallowEqual);
  const isupdatingServiceChangeRequest = useSelector(selectIsUpdatingServiceTierRequest, shallowEqual);
  const updatingserviceChangeRequestError = useSelector(selectUpdatingServiceTierRequestError, shallowEqual);
  const error = serviceChangeRequestsError || updatingserviceChangeRequestError;

  useEffect(() => {
    //fetch service requests on mounting
    dispatch(getServiceTierRequests());

    //on unmount
    return () => {
      dispatch(cancelServiceTierRequestsPoll());
      dispatch(clearReceivedServiceTierRequestsError());
    };
  }, [dispatch]);

  return (
    <Box display="flex" flexDirection="column">
      {error ? <ErrorMessage>{error}</ErrorMessage> : null}
      <StyledProvisioningPageHeading>
        Service tier change requests
        <span style={{ paddingLeft: 1, fontFamily: appTheme.viasatFontFamilyBook }}>
          ({pendingServiceChangeRequests.length})
        </span>
      </StyledProvisioningPageHeading>
      <ServiceTierRequestsTable serviceRequests={pendingServiceChangeRequests} />
      {loadingServiceChangeRequests || isupdatingServiceChangeRequest ? <ModalLoadingSpinner /> : null}
    </Box>
  );
};

export default ServiceTierChangeRequests;
